export * from "./bus";
export * from "./hotel";
export * from "./flight";
export * from "./B2CFlight";
export * from "./B2CHotel";
export * from "./B2CBus";
export * from "./B2CInsurance";

export * from "./UserType";

export const SHOW_TOAST = "SHOW_TOAST";

export function setToastMessage(message) {
  return {
    type: SHOW_TOAST,
    message,
  };
}
